import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StyledHeaderButton } from '../Header/styles';
import Utils from '../../../utils';
import { StoreState } from '../../../reducers';
import { duplicatePage } from '../../../containers/Editor/actions';

interface ButtonDuplicatePageProps {
	isDisabled: boolean;
	dispatch: Dispatch<StoreState>;
}

const ButtonDuplicatePage = ({ isDisabled, dispatch }: ButtonDuplicatePageProps) => (
	<StyledHeaderButton
		width="23px"
		height="23px"
		disabled={isDisabled}
		onClick={() => dispatch(duplicatePage())}
	>
		{Utils.getSvgIcon('iconset_uprez_duplicate')}
	</StyledHeaderButton>
);

export default ButtonDuplicatePage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonDuplicatePage/index.tsx